<script setup>
import { ref, useTemplateRef } from "vue";
import CityFooter from "./footer/CityFooter.vue";
import NetworkFooter from "./footer/NetworkFooter.vue";
import PrimaryFooter from "./footer/PrimaryFooter.vue";
import ModalBottomSheet from "../../common/global/ModalBottomSheet.vue";
import LocalesList from "./footer/LocalesList.vue";
import SecondaryFooter from "./footer/SecondaryFooter.vue";
import BottomLine from "./footer/BottomLine.vue";
import Didomi from "./footer/Didomi.vue";
defineProps({
  language: {
    type: String,
    default: "en"
  },
  country: {
    type: String,
    default: "gb"
  },
  cdnUrl: {
    type: String,
    default: ""
  },
  isDesktop: {
    type: Boolean,
    default: true
  }
});
const showCities = ref(false);
const showNetworks = ref(false);
const showLanguageModal = ref(false);
const cityFooter = useTemplateRef("cityFooter");
const networkFooter = useTemplateRef("networkFooter");
const toggleNetworks = () => {
  if (showNetworks.value) {
    networkFooter.value?.$el.classList.remove("animate-slideInUp");
    networkFooter.value?.$el.classList.add("animate-slideOutDown");
  } else {
    networkFooter.value?.$el.classList.remove("animate-slideOutDown");
    networkFooter.value?.$el.classList.add("animate-slideInUp");
  }
  setTimeout(() => {
    showNetworks.value = !showNetworks.value;
    showCities.value = showNetworks.value ? false : showCities.value;
  }, 200);
};
const toggleCities = () => {
  if (showCities.value) {
    cityFooter.value?.$el.classList.remove("animate-slideInUp");
    cityFooter.value?.$el.classList.add("animate-slideOutDown");
  } else {
    cityFooter.value?.$el.classList.remove("animate-slideOutDown");
    cityFooter.value?.$el.classList.add("animate-slideInUp");
  }
  setTimeout(() => {
    showCities.value = !showCities.value;
    showNetworks.value = showCities.value ? false : showNetworks.value;
  }, 200);
};
const toggleLanguageModal = () => {
  showLanguageModal.value = !showLanguageModal.value;
};
</script>

<template>
    <footer>
        <Didomi :language :cdnUrl />
        <div class="panel">
            <CityFooter
                v-show="showCities"
                ref="cityFooter"
                :language
                :country
                @closeCityFooter="toggleCities"
            />
            <NetworkFooter
                v-show="showNetworks"
                ref="networkFooter"
                :language
                :country
                @closeNetworkFooter="toggleNetworks"
            />
        </div>
        <PrimaryFooter
            :language
            :country
            :show-cities-from-parent="showCities"
            :show-networks-from-parent="showNetworks"
            :cdnUrl
            @toggleCityFooter="toggleCities"
            @toggleNetworkFooter="toggleNetworks"
            @toggleLanguageModal="toggleLanguageModal"
        />
        <SecondaryFooter :language :country :cdnUrl :isDesktop />
        <BottomLine
            :language
            :country
            @toggleLanguageModal="toggleLanguageModal"
        />
    </footer>

    <ModalBottomSheet :visible="showLanguageModal" @close="toggleLanguageModal">
        <LocalesList :language :country />
    </ModalBottomSheet>
</template>

<style scoped>
footer {
  @apply relative w-full bg-white z-10 h-auto divide-y-[1px] divide-zinc-200;
}
footer > * {
  @apply transition-all duration-300;
}
footer .panel {
  @apply m-0 border-none;
}
footer .panel .animate-slideInUp {
  animation: slideInUp 0.5s ease-in-out;
}
footer .panel .animate-slideOutDown {
  animation: slideOutDown 0.5s ease-in-out;
}
@keyframes slideInUp {
  from {
    transform: translateY(10%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 100%;
  }
}
@keyframes slideOutDown {
  from {
    transform: translateY(0);
    opacity: 100%;
  }
  to {
    transform: translateY(20%);
    opacity: 0;
  }
}
</style>
